/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IAllowableFreightCalculation } from './DataServiceEntities.g';
import { getAllowableFreightAsync } from './DataActionExtension.g';
import { CartLine } from '@msdyn365-commerce/retail-proxy';
/**
 * GetAllowableFreightCalculation Input Action
 */
export class GetAllowableFreightCalculationInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public cartId: string;
    public cartLines: CartLine[];
    constructor(cartId: string, cartLines: CartLine[]) {
        this.cartId = cartId;
        this.cartLines = cartLines;
    }

    //Build cache key
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => this.cartLines.map(cl => `${cl.ItemId}[${cl.Quantity}]`).join('|');
    public getCacheObjectType = () => 'freight-calculation';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const cartId = 'test'; //todo
    return new GetAllowableFreightCalculationInput(cartId, []);
};

async function action(input: GetAllowableFreightCalculationInput, ctx: Msdyn365.IActionContext): Promise<IAllowableFreightCalculation> {
    return getAllowableFreightAsync({ callerContext: ctx }, input.cartId);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IAllowableFreightCalculation>>action,
    id: 'GetAllowableFreightCalculation',
    input: createInput
});
